export default __webpack_public_path__ + "static/Civili-ee69998e10599cb25fff9250bfec984b.jpg";